export const STATISTICS_CALL = 'STATISTICS_CALL';
export const STATISTICS_RESPONSE = 'STATISTICS_RESPONSE';